import useAxios from 'hooks/useAxios';

/**
 * Get giveaway leaderboard
 * @param {Object} params - Query parameters
 * @param {number} params.limit - Number of entries to return (default: 50, max: 100)
 */
export async function getGiveawayLeaderboard(params = {}) {
  const api = useAxios();

  try {
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append('limit', params.limit);

    const res = await api.get(
      `/giveaway/leaderboard?${queryParams.toString()}`,
    );
    return res;
  } catch (err) {
    return err;
  }
}
